import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated } from '@/services/authSession'
import Login from '@/views/MainPage/LoginPage.vue'
import LandingPage from '@/views/MainPage/LandingPage.vue'
import PrivacyPolicyPage from '@/views/MainPage/PrivacyPolicyPage.vue'

const routes = [
  {
    path: '/Landing',
    name: 'Landing',
    component: LandingPage,
    meta: { requiresAuth: true }
  },
  {
    path: '',
    name: 'Login',
    component: Login,
    meta: { guestOnly: true }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authed = isAuthenticated()

  if (to.meta.requiresAuth && !authed) {
    next({
      path: '/',
      query: to.fullPath !== '/Landing' ? { redirect: to.fullPath } : {}
    })
    return
  }

  if (to.meta.guestOnly && authed) {
    next('/Landing')
    return
  }

  next()
})

export default router
